<template>
    <v-container grid-list-sm fluid class="body-color">
      <div v-if="isMobile()">
        <v-container
          class="border-radius"
          
        >
  
          <!--========= Details Assurance cas Automobile MOBILE ================-->
          <!--========= Details Assurance cas Automobile MOBILE ================-->
          <!--========= Details Assurance cas Automobile MOBILE ================-->
          <!--========= Details Assurance cas Automobile MOBILE ================-->
          <div
            data-v-221edead=""
            v-if="Devis_pour_souscription.brancheid.branche == 'Automobile'"
            class="w-100 Results"
            pricing="true"
            style="
              --custom-color-primary: #35ce7e;
              --custom-color-primary-light: #5cc7000d;
            "
          >
  
            <!-- <div data-v-221edead="" class="container">
              <div data-v-221edead="" class="results-deals">
                <div data-v-221edead="" id="results-table">
                  <div data-v-221edead="" style="top: 0px; width: 100%">
                    <div
                      data-v-221edead=""
                      class="
                        card-default
                        result
                        text-center
                        naoassur
                        elevation-10
                      "
                    >
                      <div data-v-221edead="" class="card-default-body">
                        <h1 class="field-title row justify-content-center">
                          {{$t('paiement.objet_assure_title')}}
                        </h1>
                        <div
                          data-v-221edead=""
                          class="logo-company logo-company-economy"
                        >
                          <ul
                            class="to-left policeLato"
                            v-for="(
                              auto, index
                            ) in Devis_pour_souscription.vehicules"
                            :key="index"
                          >
                            <li class="field-sub-title">
                              {{$t('paiement.automobile.objet_assure_colonne.marque')}} :
                              <span class="field-sub-title to-right">{{
                                auto.marque
                              }}</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{$t('paiement.automobile.objet_assure_colonne.model')}} :
                              <span class="field-sub-title to-right">{{
                                auto.model
                              }}</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{$t('paiement.automobile.objet_assure_colonne.immatriculation')}} :
                              <span class="field-sub-title to-right">{{
                                auto.immatriculation
                              }}</span>
                            </li>
  
                            <li
                              class="field-sub-title"
                              v-show="auto.categorie == 'utilitaire'"
                            >
                            {{$t('paiement.automobile.objet_assure_colonne.categorie')}} :
                              <span class="field-sub-title to-right">{{
                                auto.categorie
                              }}</span>
                            </li>
  
                            <li
                              class="field-sub-title"
                              v-show="auto.categorie == 'utilitaire'"
                            >
                            {{$t('paiement.automobile.objet_assure_colonne.option_utilitaire')}} :
                              <span class="field-sub-title to-right">{{
                                auto.optionUtilitaire
                              }}</span>
                            </li>
  
                            <li
                              class="field-sub-title"
                              v-show="auto.categorie == 'utilitaire'"
                            >
                            {{$t('paiement.automobile.objet_assure_colonne.tonnage')}} :
                              <span class="field-sub-title to-right">{{
                                auto.tonnage
                              }}</span>
                            </li>
  
                            <li
                              class="field-sub-title"
                              v-show="auto.categorie == '2_roues'"
                            >
                            {{$t('paiement.automobile.objet_assure_colonne.volumetrie_2_roues')}} :
                              <span class="field-sub-title to-right">{{
                                auto.volumetrie2_roues
                              }}</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{$t('paiement.automobile.objet_assure_colonne.valeur_neuf')}} :
                              <span class="field-sub-title to-right">{{
                                auto.valeur
                              }}</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{$t('paiement.automobile.objet_assure_colonne.valeur_venale')}} :
                              <span class="field-sub-title to-right">{{
                                auto.valeur_venale
                              }}</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{$t('paiement.automobile.objet_assure_colonne.force')}} :
                              <span class="field-sub-title to-right">{{
                                auto.force
                              }}</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{$t('paiement.automobile.objet_assure_colonne.age_vehicule')}} :
                              <span class="field-sub-title to-right"
                                >{{ auto.age }} {{ auto.annee_mois }}</span
                              >
                            </li>
  
                            <li class="field-sub-title">
                              {{$t('paiement.automobile.objet_assure_colonne.nbre_place')}} :
                              <span class="field-sub-title to-right">{{
                                auto.nbplace
                              }}</span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div data-v-221edead="" class="container">
              <div data-v-221edead="" class="results-deals">
                <div data-v-221edead="" id="results-table">
                  <div data-v-221edead="" style="top: 0px; width: 100%">
                    <div
                      data-v-221edead=""
                      class="
                        card-default
                        result
                        text-center
                        naoassur
                        elevation-10
                      "
                    >
                      <div data-v-221edead="" class="card-default-body">
                        <h1 class="field-title row justify-content-center">
                          {{$t('paiement.garantie_souscrite_label')}}
                        </h1>
                        <div
                          data-v-221edead=""
                          class="logo-company logo-company-economy"
                          v-show="
                            this.$store.state.devispayement.devis.brancheid
                              .branche == 'Automobile'
                          "
                        >
                          <ul
                            class="to-left pb-3 policeLato"
                            v-for="(gar, index) in listegaranties"
                            :key="index"
                          >
                            <li
                              class="ml-2 field-sub-title"
                              v-for="(g, index) in gar"
                              :key="index"
                            >
                              <span
                                class="field-sub-title to-left"
                                style="color: #ffa409"
                                >{{ g }}</span
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
  
            <!-- <div data-v-221edead="" class="container">
              <div data-v-221edead="" class="results-deals">
                <div data-v-221edead="" id="results-table">
                  <div data-v-221edead="" style="top: 0px; width: 100%">
                    <div
                      data-v-221edead=""
                      class="
                        card-default
                        result
                        text-center
                        naoassur
                        elevation-10
                      "
                    >
                      <div data-v-221edead="" class="card-default-body">
                        <h1 class="field-title row justify-content-center">
                          {{$t('paiement.autre_infos_title')}}
                        </h1>
                        <div
                          data-v-221edead=""
                          class="logo-company logo-company-economy"
                          v-show="
                            this.$store.state.devispayement.devis.brancheid
                              .branche == 'Automobile'
                          "
                        >
                          <ul class="to-left policeLato">
                            <li class="field-sub-title">
                              {{$t('paiement.automobile.autre_infos_colonne.date_effet')}} :
                              <span class="field-sub-title to-right">{{
                                DateFormater(Devis_pour_souscription.dateEffet)
                              }}</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{$t('paiement.automobile.autre_infos_colonne.date_echeance')}} :
                              <span class="field-sub-title to-right">{{
                                DateFormater(Devis_pour_souscription.dateEcheance)
                              }}</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{$t('paiement.automobile.autre_infos_colonne.assureur')}} :
                              <span class="field-sub-title to-right">{{
                                Devis_pour_souscription.partenaireid.societe
                              }}</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{$t('paiement.automobile.autre_infos_colonne.date_souscription')}} :
                              <span class="field-sub-title to-right">{{
                                DateFormater(
                                  Devis_pour_souscription.dateSouscription
                                )
                              }}</span>
                            </li>
  
                            <li class="field-sub-title">
                              {{$t('paiement.automobile.autre_infos_colonne.beneficiaire')}} :
                              

                              <span class="field-sub-title to-right"
                                >FAA
                                </span>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>

            <div data-v-221edead="" class="w-100 Results" pricing="true">
              <div role="tabpanel" id="devis_auto" aria-labelledby="step-devis_auto">
            <div data-v-0d43d413="">
              <div data-v-0d43d413="" class="fields">
                <div data-v-0d43d413="" class="modern-checkout-title">
                  <h2>{{$t('paiement.detail_assurance_label')}}</h2>
                </div>
              </div>
            </div>
              </div>
                <!-- Modern Summary Section autres informations -->
                <div class="modern-summary-section" v-show="this.$store.state.devispayement.devis.brancheid.branche == 'Automobile'">
                  <div class="summary-card" v-for="(auto, index) in Devis_pour_souscription.vehicules" :key="index">
                    <h4 class="summary-title">{{$t('paiement.objet_assure_title')}}</h4>
                    

                    <div class="summary-item">
                      <span class="summary-label">{{$t('paiement.automobile.objet_assure_colonne.marque')}}</span>
                      <span class="summary-value">{{auto.marque}}</span>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label">{{$t('paiement.automobile.objet_assure_colonne.model')}}</span>
                      <span class="summary-value">{{auto.model}}</span>
                    </div>

                     <div class="summary-item">
                      <span class="summary-label">{{$t('paiement.automobile.objet_assure_colonne.immatriculation')}}</span>
                      <span class="summary-value">{{auto.immatriculation}}</span>
                    </div>

                    <div class="summary-item" v-show="auto.categorie == 'utilitaire'">
                      <span class="summary-label">{{$t('paiement.automobile.objet_assure_colonne.categorie')}}</span>
                      <span class="summary-value">{{auto.categorie}}</span>
                    </div>

                    <div class="summary-item" v-show="auto.categorie == 'utilitaire'">
                      <span class="summary-label">{{$t('paiement.automobile.objet_assure_colonne.option_utilitaire')}}</span>
                      <span class="summary-value">{{auto.optionUtilitaire}}</span>
                    </div>

                     <div class="summary-item" v-show="auto.categorie == 'utilitaire'">
                      <span class="summary-label">{{$t('paiement.automobile.objet_assure_colonne.tonnage')}}</span>
                      <span class="summary-value">{{auto.tonnage}}</span>
                    </div>

                    <div class="summary-item" v-show="auto.categorie == '2_roues'">
                      <span class="summary-label">{{$t('paiement.automobile.objet_assure_colonne.volumetrie_2_roues')}}</span>
                      <span class="summary-value">{{auto.volumetrie2Roues}}</span>
                    </div>

                      <div class="summary-item">
                      <span class="summary-label">{{$t('paiement.automobile.objet_assure_colonne.valeur_neuf')}}</span>
                      <span class="summary-value" v-if="auto.valeur != null">{{auto.valeur.toLocaleString()}} FCFA</span>
                    </div>

                     <div class="summary-item">
                      <span class="summary-label">{{$t('paiement.automobile.objet_assure_colonne.valeur_venale')}}</span>
                      <span class="summary-value"v-if="auto.valeur_venale != null">{{auto.valeur_venale.toLocaleString()}} FCFA</span>
                    </div>

                     <div class="summary-item">
                      <span class="summary-label">{{$t('paiement.automobile.objet_assure_colonne.force')}}</span>
                      <span class="summary-value">{{auto.force}}</span>
                    </div>

                     <div class="summary-item">
                      <span class="summary-label">{{$t('paiement.automobile.objet_assure_colonne.age_vehicule')}}</span>
                      <span class="summary-value">{{ auto.age }} {{ auto.annee_mois }}</span>
                    </div>

                      <div class="summary-item">
                      <span class="summary-label">{{$t('paiement.automobile.objet_assure_colonne.nbre_place')}}</span>
                      <span class="summary-value">{{ auto.nbplace }}</span>
                    </div>

                  </div>
                </div>

               <!-- Modern Summary Section Garanties -->
                <div class="modern-summary-section" v-show="this.$store.state.devispayement.devis.brancheid.branche == 'Automobile'">
                  <div class="summary-card">
                    <h4 class="summary-title">{{$t('paiement.garantie_souscrite_label')}}</h4>
                    

                    <div class="summary-item">
                      <span class="summary-label">Garanties</span>
                      <span class="summary-value" style="display: grid;" v-for="(gar, index) in listegaranties" :key="index">
                        <span style="color:#ffa409" v-for="(g, index) in gar"
                              :key="index">{{g}}</span>
                      </span>
                    </div>
                  </div>
                </div>

                <!-- Modern Summary Section autres informations -->
                <div class="modern-summary-section" v-show="this.$store.state.devispayement.devis.brancheid.branche == 'Automobile'">
                  <div class="summary-card">
                    <h4 class="summary-title">{{$t('paiement.autre_infos_title')}}</h4>
                    

                    <div class="summary-item">
                      <span class="summary-label">{{$t('paiement.automobile.autre_infos_colonne.date_effet')}}</span>
                      <span class="summary-value">{{DateFormater(Devis_pour_souscription.dateEffet)}}</span>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label">{{$t('paiement.automobile.autre_infos_colonne.date_echeance')}}</span>
                      <span class="summary-value">{{DateFormater(Devis_pour_souscription.dateEcheance)}}</span>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label">{{$t('paiement.automobile.autre_infos_colonne.assureur')}}</span>
                      <span class="summary-value">{{Devis_pour_souscription.partenaireid.societe}}</span>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label">{{$t('paiement.automobile.autre_infos_colonne.date_souscription')}}</span>
                      <span class="summary-value">{{DateFormater(Devis_pour_souscription.dateSouscription)}}</span>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label">{{$t('paiement.automobile.autre_infos_colonne.beneficiaire')}}</span>
                      <span class="summary-value">{{Devis_pour_souscription.proprietaire.prenom}} {{Devis_pour_souscription.proprietaire.nom}}</span>
                    </div>

                  </div>
                </div>

            </div>
 
  
      
        </v-container>
      </div>
  
      <div v-if="isDesktop()">
        <!--========= Details Assurance cas Automobile DESKTOP ================-->
        <!--========= Details Assurance cas Automobile DESKTOP ================-->
        <!--========= Details Assurance cas Automobile DESKTOP ================-->
        <!--========= Details Assurance cas Automobile DESKTOP ================-->
        <div v-if="Devis_pour_souscription.brancheid.branche == 'Automobile'">
          <div v-if="isDesktop()">
            <div data-v-221edead="" class="container">
              <div
                role="tabpanel"
                id="devis_auto"
                aria-labelledby="step-devis_auto"
              >


              <div>
          <!-- 3 divs alignées horizontalement -->
            <div data-v-0d43d413="">
                <div data-v-0d43d413="">
                  <div class="modern-checkout-title desktop">
                    <h2 style="margin-bottom: -20px;">{{$t('paiement.detail_assurance_label')}}</h2>
                  </div>
                </div>
              </div>
          <div style="display: flex; justify-content: space-between; gap: 16px; flex-wrap: wrap;" class="container">
            <div style="flex: 1; min-width: 200px;">
                <div class="modern-summary-section desktop">
              <div class="summary-card desktop">
                <h4 class="summary-title">{{$t('paiement.objet_assure_title')}}</h4>
                <div class="summary-content">
                  <div class="summary-left" v-for="(auto, index) in Devis_pour_souscription.vehicules" :key="index">
                    <div class="summary-item">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.objet_assure_colonne.marque')}}</span>
                      <span class="summary-value">{{auto.marque}}</span>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.objet_assure_colonne.model')}}</span>
                      <span class="summary-value">{{auto.model}}</span>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.objet_assure_colonne.immatriculation')}}</span>
                      <span class="summary-value">{{auto.immatriculation}}</span>
                    </div>

                     <div class="summary-item" v-show="auto.categorie == 'utilitaire'">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.objet_assure_colonne.categorie')}}</span>
                      <span class="summary-value">{{auto.categorie}}</span>
                    </div>

                      <div class="summary-item" v-show="auto.categorie == 'utilitaire'">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.objet_assure_colonne.option_utilitaire')}}</span>
                      <span class="summary-value">{{auto.optionUtilitaire}}</span>
                    </div>

                      <div class="summary-item" v-show="auto.categorie == 'utilitaire'">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.objet_assure_colonne.tonnage')}}</span>
                      <span class="summary-value">{{auto.tonnage}}</span>
                    </div>

                       <div class="summary-item" v-show="auto.categorie == '2_roues'">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.objet_assure_colonne.volumetrie_2_roues')}}</span>
                      <span class="summary-value">{{auto.volumetrie2_roues}}</span>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.objet_assure_colonne.valeur_neuf')}}</span>
                      <span class="summary-value" v-if="auto.valeur !== null">{{auto.valeur.toLocaleString()}} FCFA</span>
                    </div>

                     <div class="summary-item">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.objet_assure_colonne.valeur_venale')}}</span>
                      <span class="summary-value" v-if="auto.valeur_venale !== null">{{auto.valeur_venale.toLocaleString()}} FCFA</span>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.objet_assure_colonne.force')}}</span>
                      <span class="summary-value">{{auto.force}}</span>
                    </div>

                     <div class="summary-item">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.objet_assure_colonne.age_vehicule')}}</span>
                      <span class="summary-value">{{ auto.age }} {{ auto.annee_mois }}</span>
                    </div>

                    
                  </div>
                </div>
              </div>
            </div>
            </div>
            <div style="flex: 1; min-width: 200px;">
                <div class="modern-summary-section desktop">
              <div class="summary-card desktop">
                <h4 class="summary-title">{{$t('paiement.garantie_souscrite_label')}}</h4>
                <div class="summary-content">
                  <div class="summary-left">
                    

                    <div class="summary-item">
                      <span class="summary-label-desktop">{{ $t('paiement.frais_livraison') }}</span>
                      <span class="summary-value"v-for="(gar, index) in listegaranties":key="index">
                        <span style="display: grid;color: #ffa409;" v-for="(g, index) in gar" :key="index">{{g}}</span>
                      </span>
                    </div>

                    
                  </div>
                </div>
              </div>
            </div>
            </div>
            <div style="flex: 1; min-width: 200px;">
                <div class="modern-summary-section desktop">
              <div class="summary-card desktop">
                <h4 class="summary-title">{{$t('paiement.autre_infos_title')}}</h4>
                <div class="summary-content">
                  <div class="summary-left">
                    

                    <div class="summary-item">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.autre_infos_colonne.date_effet')}}</span>
                      <span class="summary-value">{{DateFormater(Devis_pour_souscription.dateEffet)}}</span>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.autre_infos_colonne.date_echeance')}}</span>
                      <span class="summary-value">{{DateFormater(Devis_pour_souscription.dateEcheance)}}</span>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.autre_infos_colonne.assureur')}}</span>
                      <span class="summary-value">{{Devis_pour_souscription.partenaireid.societe}}</span>
                    </div>

                     <div class="summary-item">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.autre_infos_colonne.date_souscription')}}</span>
                      <span class="summary-value">{{DateFormater(Devis_pour_souscription.dateSouscription)}}</span>
                    </div>

                    <div class="summary-item">
                      <span class="summary-label-desktop">{{$t('paiement.automobile.autre_infos_colonne.beneficiaire')}}</span>
                      <span class="summary-value">{{Devis_pour_souscription.proprietaire.prenom}} {{Devis_pour_souscription.proprietaire.nom}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-container>
  </template>
  
  <script>
  import Api from "../../services/Api";
  import store from "./../../store/store";
  import getUpay from "../../services/getUpay";
  import dayjs from "dayjs";
  //import getOm from "../services/getOm";
  import getOrabank from "../../services/orabank";
  import ville from "./../../common/ville";
  import FreeMoney from "./../../services/freemoneyapi";
  import RotateLoader from "vue-spinner/src/BounceLoader.vue";
  import PushInDataLayer from "../../services/TagManager";
  import wavepayment from "../../services/WaveServices"
  
  export default {
    data() {
      return {
        showPopUpBeneficiaireExistantSante:false,
        choixOrangeMoneyPopup : false,
        choixOrangeMoney : null,
        ListAssure: [],
        listAssure : [],
        ageAssure : false,
        nbAssureAdded : 0,
        PopupOM:false,
        qrCodeImg:"",
        PopupOMQRcode :false,
        telephone_client:null,
        code_otp:null,
        montant : 0,
        taxe : 0,
        accessoire: 25000,
        primeTTC:0,
        prime_nette : 0,
        data:[],
  
        wave_nom_prenom: null,
        wave_phone: null,
        wave_idcard: null,
        wave_amount: null,
        wave_currency:"XOF",
        /*====*/
        wave_qr_code: false,
        nom: null,
        prenom: null,
        adresse: null,
        telephone: null,
        numero_cni: null,
        pays: null,
        genre: null,
        showPopUpBeneficiaireSante: false,
        tab_perso: [],
        maxPersonne: null,
        //
        GtmAssistanceVal: {},
        addedInTheCard: null,
        aStorMap: false,
        disable: false,
        devis_price: null,
        placeholderprenom: store.state.user.prenom,
        placeholdernom: store.state.user.nom,
        numTelephone: store.state.user.telephone_port,
        passenger_birthady_age: null,
        snipperfree: false,
        description:
          "Paiement de l'assurance " +
          store.state.devispayement.devis.brancheid.branche +
          " No: " +
          store.state.devispayement.devis.numeroDevis +
          ". Assureur: " +
          store.state.devispayement.devis.partenaireid.societe,
        dialogom: false,
        iframe: {
          src: "",
          loaded: false,
        },
        // numTelephone : '' ,
        amenities: [1, 4],
        headers: [
          {
            text: "Marque & Modèle",
            value: "marque",
          },
          {
            text: "Immatriculation",
            value: "immatriculation",
          },
          {
            text: "Catégorie",
            value: "catégorie",
          },
          {
            text: "Force",
            value: "force",
          },
          {
            text: "Age",
            value: "age",
          },
          {
            text: "Valeur neuf",
            value: "valeur",
          },
          {
            text: "Valeur actuelle",
            value: "valeur_actuelle",
          },
          {
            text: "Nbr places",
            value: "nbplace",
          },
          {
            text: "Actions",
          },
        ],
        fraisLiv: 0,
        fraisPaiement: 0,
        Testons: false,
        itemsGenre: ["Homme", "Femme"],
        adresselivraison: "",
        autoHeight: true,
        x: null,
        dialogAlert: false,
        dialogPopupFileCaution : false,
        Devis_pour_souscription: [],
        mode_livraison: null,
        listVille: ville,
        mention_ttc: null,
        showPaymentBLock: false,
        menuDelivrance: false,
        dialogLoading: false,
        menuExpiration: false,
        mode_payement: null,
        notifDeviParMail: null,
        countries: null,
        ville: null,
        quartier: "",
        listegaranties: [],
        marque: null,
        frais_livraison: null,
        branche: null,
        continue_btn: false,
        dialog: false,
        city: null,
        datePickerDateNais: false,
        IsPaid: false,
        contratToStore: null,
        // listeVille: ville,
        Popupadresse: false,
        freepayment: false,
        orabankpayment: false,
        // selectedVille: null,
        notif: null,
        ExitByUser: true,
        Mano: null,
        show: false,
        ToastTabSucess: {
          // Customized options for success toast
          theme: "toasted-primary",
          position: "top-center",
          duration: 5000,
          fitToScreen: true,
          type: "success",
          className: "custom-success-class",
        },
        ToastTabError: {
          // Customized options for error toast
          theme: "toasted-primary",
          position: "top-center",
          duration: 5000,
          fitToScreen: true,
          type: "error",
        },
        assistanceDialog: false,
        itema: ["Le plus tôt possible", "Dans la matinée", "Dans la journée"],
        rappel: ["Whatsapp", "Appel", "Email"],
        objet: [
          "Devis",
          "Souscription",
          "Contrat",
          "Paiement",
          "Conseil",
          "Sinistre",
          "Autres",
        ],
        horaire: null,
        canal: null,
        name: null,
        tel: null,
        objetRappel: null,
        remarques: null,
        timer: "",
        DeliveryCost: null,
      };
    },
  
    components: {
      RotateLoader,
    },
  
    created() {
      this.fetchEventsList();
      this.timer = setInterval(this.fetchEventsList, 60000);
  
      // EXECUTION AUTOMATIQUE ET PERIODIQUE DES FONCTIONS POUR
      // DESACTIVER LES CHOIX EXPRESS DU POPUP LIVRAISON
      let result = this.$crontab.addJob({
        name: "counter",
        interval: {
          hours: "17",
          day: "*",
        },
        job: this.disableExpress,
      });
  
      let stop = this.$crontab.addJob({
        name: "stop",
        interval: {
          hours: "8",
          day: "*",
        },
        job: this.enableExpress,
      });
    },
  
    methods: {
      closePopupOm(){
        this.mode_payement = null;
        this.PopupOM = false;
        this.choixOrangeMoney = null;
      },
  
      closeQrCodePopupOm(){
        this.mode_payement = null;
        this.PopupOMQRcode = false;
        this.choixOrangeMoney = null;
      },
  
      checkToken() 
      {
              Api().get('user/check/token')
              .then((resultat) => {
              // verifie si le token exist
              if (!resultat.data.ok) {
                  store.state.isUserLoggedIn = false;
                  store.dispatch("setUser", {});
                  store.dispatch("setToken", {});
                  this.showLoginForm = true
                  }
              }).catch((err) => {
                  console.log(err)
                  // verifie  si le token est expiré
                  if(err.response.data.ok === false){
                  store.state.isUserLoggedIn = false;
                  store.dispatch("setUser", {});
                  store.dispatch("setToken", {});
                  this.showLoginForm = true
                  }
              });
      },
  
      orange_money_payment_end()
      {
        if(this.telephone_client && this.code_otp)
        {
           const data = {
              primettc:this.mention_ttc,
              telephone_client:this.telephone_client,
              code_otp:this.code_otp,
              reference:this.Devis_pour_souscription.numeroDevis
            }
            Api().post("orangemoney/onestep", data)
            .then((result) => {
              this.$router.go(this.$router.push('/payment/orangemoneyrep'))
            }).catch((err) => {
                if(err.response.data.code!="" && err.response.data.detail!=""){
                  this.$toasted.show(err.response.data.detail, this.ToastTabError)
                }else{
                  this.$toasted.show("L'opération a échoué veuillez réessayer !",this.ToastTabError)
                }
              });
        }else{
          this.$toasted.show("Numéro téléphone et Code OTP obligatoire !",this.ToastTabError)
        }
       
      },
  
  
      orange_money_qrcode_payment_end()
      {
        if(this.telephone_client)
        {
           const data = {
              primettc: this.mention_ttc,
              reference:this.Devis_pour_souscription.numeroDevis
          }
          Api().post("orangemoney/qrcode", data)
          .then((result) => {
              if(this.isDesktop())
              {
                this.qrCodeImg     = "data:image/jpg;base64,"+result.data.qrCode
                this.PopupOMQRcode = true
                this.PopupOM = false
                setTimeout(() => {this.$router.go(this.$router.push('/payment/orangemoneyrep')) }, 15000);
              }else{
                window.open(result.data.deepLink)
              }
             
          }).catch((err) => {
              if(err.response.data.code!="" && err.response.data.detail!="")
              {
                this.$toasted.show(err.response.data.detail, this.ToastTabError)
              }else{
                this.$toasted.show("L'opération a échoué veuillez réessayer !",this.ToastTabError)
              }
            });
        }else{
          this.$toasted.show("Numéro de téléphone obligatoire !",this.ToastTabError)
        }
       
      },
  
  
      disabledAfterToday(date){
        const today = new Date()
        return date > today
      },
    
  
      disabledBeforeToday(date) {
        const today = dayjs(new Date()).add(-1, 'day')
        this.date_expiration = null
        return date > today;
      },
  

      
      disabledBeforeTodayDateNaissance(date) {
        const today = dayjs(new Date()).add(-1, 'day')
        return date > today;
      },
  
      goToHome() {
        this.$router.go(this.$router.push("/"));
      },
      yearsDiffDateDelivre() {
        const date1 = dayjs(this.date_delivrance);
        const date2 = dayjs(this.Devis_pour_souscription.dateDepart);
        let daydiff = date2.diff(date1, "days");
        this.ageDepart = daydiff;
  
        if (this.ageDepart < 0) {
          this.ageDepart = null;
          this.annee_mois = "";
          this.$toasted.show(
            "Erreur, date postérieure à la date de départ! ",
            this.ToastTabError
          );
          this.date_delivrance = null;
        } else if (this.ageDepart <= 29) {
          this.an = this.annee_mois = "jour(s)";
        } else if ((this.ageDepart >= 30, this.ageDepart <= 360)) {
          let year = Math.floor(this.ageDepart / 30);
          this.ageDepart = year;
          this.an = this.annee_mois = "mois";
        } else if (this.date_delivrance >= 360) {
          let year = Math.floor(this.age / 360);
          this.ageDepart = year;
          this.annee = year;
          this.year = this.ageDepart;
          this.an = this.annee_mois = "an(s)";
        }
      },
      yearsDiffDateExpire() {
        const date1 = dayjs(this.date_expiration);
        const date2 = dayjs(this.date_delivrance);
        let daydiff = date2.diff(date1, "days");
  
        this.ageArrivee = daydiff;
  
        if (this.ageArrivee > 0) {
          this.ageArrivee = null;
          this.annee_mois = "";
          this.$toasted.show(
            "Erreur, date postérieure à la date de délivrance! ",
            this.ToastTabError
          );
          this.date_expiration = null;
        }
      },
  
      Detail_info_beneficiaires() {
        if (this.nom && this.prenom && this.adresse) {
          if (this.telephone && this.numero_cni && this.pays && this.genre) {
            let Un_beneficiaire = {
              nom: this.nom,
              prenom: this.prenom,
              adresse: this.adresse,
              telephone: this.telephone,
              numero_cni: this.numero_cni,
              pays: this.pays,
              genre: this.genre,
            };
  
            if (this.tab_perso.length + 1 <= this.maxPersonne) {
              this.tab_perso.push(Un_beneficiaire);
              this.$store.dispatch("setListeBeneficiaire", this.tab_perso);
              this.showValiderBtn = true;
              this.nom = "";
              this.prenom = "";
              this.adresse = "";
              this.telephone = "";
              this.numero_cni = "";
            } else {
              this.$toasted.show(
                "Le nombre maximum de personnes est atteind ! ",
                this.ToastTabError
              );
            }
          } else {
            this.$toasted.show(
              "Tous les (*) sont obligatoires ! ",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Tous les (*) sont obligatoires ! ",
            this.ToastTabError
          );
        }
      },
  
      /**
       * On applique un pourcentage au montant TTC
       * ce pourcentage est supporte par le client et reverse au partenaires
       * upay, intouch, orabank et free
       */
      calculFraisPaiement() {
        /**
         * Orange Money
         * Free Money
         * upay cash
         * wave
         */
        if (
          this.mode_payement == "mobile_money" ||
          this.mode_payement == "free_money" ||
          this.mode_payement == "reseau_partenaire" ||
          this.mode_payement == "wave"
        ) {
          let FP =((this.Devis_pour_souscription.prime_ttc + this.fraisLiv) * 0.01) / (1 - 0.01);
          this.fraisPaiement = Math.round(FP * 100) / 100;
          this.mention_ttc = Math.ceil(this.Devis_pour_souscription.prime_ttc + this.fraisPaiement + this.fraisLiv
          );
        } else if (
        /**
         * OraBank
         * Intouch
         */
          this.mode_payement == "carte_bancaire" ||
          this.mode_payement == "intouch"
        ) {
          let FP =
            ((this.Devis_pour_souscription.prime_ttc + this.fraisLiv) * 0.02) / (1 - 0.02);
          this.fraisPaiement = Math.round(FP * 100) / 100;
          this.mention_ttc = Math.ceil(
            this.Devis_pour_souscription.prime_ttc +
              this.fraisPaiement +
              this.fraisLiv
          );
        } else if (this.mode_payement == "autre_paiement") {
        /**
         * Upay
         *
         */
          let FP =
            ((this.Devis_pour_souscription.prime_ttc + this.fraisLiv) * 0.0125) /
            (1 - 0.0125);
          this.fraisPaiement = Math.round(FP * 100) / 100;
          this.mention_ttc = Math.ceil(
            this.Devis_pour_souscription.prime_ttc +
              this.fraisPaiement +
              this.fraisLiv
          );
        }
      },
  
      calculFraisLiv() {
        let ST = this.mention_ttc;
        let SN = Math.trunc(this.Devis_pour_souscription.prime_ttc);
        let frais = ST - SN;
        this.fraisLiv = frais;
      },
  
      disableExpress() {
        this.disable = true;
      },
  
      enableExpress() {
        this.disable = false;
      },
  
      load: function () {
        this.iframe.loaded = true;
      },
  
      cancelPaiement() {
        this.Popupadresse = false
        this.adresse = false;
        this.mode_livraison = null;
        this.adresselivraison = "";
      },
  
      cancelFree() {
        (this.freepayment = false), (this.mode_livraison = null);
      },
  
      cancelOrab() {
        this.orabankpayment = false;
      },
  
      /*=============Filtre sans le + ni lettre sur les champs de type number ===========*/
      onlyNumber($event) {
        let NumOnly = $event.NumOnly ? $event.NumOnly : $event.which;
        if ((NumOnly < 48 || NumOnly > 57) && NumOnly !== 46) {
          $event.preventDefault();
        }
      },
  
      fetchEventsList() {
        this.Mano = this.Mano - 1;
        if (this.Mano == 0) {
          this.ExitByUser = false;
          this.$router.go(this.$router.push("/"));
        }
      },
  
      isMobile: function () {
        if (screen.width <= 760) {
          return true;
        } else {
          return false;
        }
      },
  
      isTablette() {
        if (screen.width > 425 && screen.width <= 768) {
          return true;
        } else {
          return false;
        }
      },
  
      isDesktop: function () {
        if (screen.width > 768) {
          return true;
        } else {
          return false;
        }
      },
  
      getImgUrl(pic) {
        if (pic) {
          return pic;
        } else {
          return require("../../assets/img/assuraf_sm.png");
        }
      },
  
      // Get la liste des pays
      getListePays: function () {
        Api()
          .get("/pays/all")
          .then((response) => {
            this.countries = response.data;
          })
          .catch((err) => {
            err;
          });
      },
  
      showListCity() {
        if (
          this.prix_livraison == "dakar_normal" ||
          this.prix_livraison == "dakar_express"
        ) {
          this.dakar = true;
          this.ville = this.listVille.Dakar;
          this.quartier = null;
        } else if (
          this.prix_livraison == "banlieue_normal" ||
          this.prix_livraison == "banlieue_express"
        ) {
          this.dakar = true;
          this.ville = this.listVille.Banlieue;
          this.quartier = null;
        }
      },
  
      getAdressLivraison: function () {
        let delivery_cost = 0;
  
        if (this.prix_livraison) {
          if (this.prix_livraison == "dakar_normal") {
            this.mention_ttc = parseInt(this.svgTTC) + 1500;
            delivery_cost = 1500;
            this.DeliveryCost = 1500;
          } else if (this.prix_livraison == "dakar_express") {
            this.mention_ttc = parseInt(this.svgTTC) + 2000;
            delivery_cost = 2000;
            this.DeliveryCost = 2000;
          } else if (this.prix_livraison == "banlieue_normal") {
            this.mention_ttc = parseInt(this.svgTTC) + 2000;
            delivery_cost = 2000;
            this.DeliveryCost = 2000;
          } else if (this.prix_livraison == "banlieue_express") {
            this.mention_ttc = parseInt(this.svgTTC) + 2500;
            delivery_cost = 2500;
            this.DeliveryCost = 2500;
          }
          if (this.adresselivraison && this.quartier) {
            localStorage.setItem("adressliv", this.adresselivraison);
            localStorage.setItem("quartier", this.quartier);
            localStorage.setItem("typeLivraison", this.prix_livraison);
            localStorage.setItem("delivery_cost", delivery_cost);
            this.Popupadresse = false;
          } else {
            this.$toasted.show(
              "Adresse de livraison obligatoire ! ",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "veuillez choisir un mode de livraison ! ",
            this.ToastTabError
          );
        }
        this.calculFraisLiv();
        this.calculFraisPaiement();
      },
  
      AddAssistance() {
        if (
          this.horaire &&
          this.canal &&
          this.name &&
          this.tel &&
          this.objetRappel &&
          this.remarques
        ) {
          const assist = {
            horaire: this.horaire,
            canal: this.canal,
            name: this.name,
            tel: this.tel,
            objetRappel: this.objetRappel,
            remarques: this.remarques,
            userid: store.state.user._id,
          };
  
          let Gtm2 = {
            branche: this.GtmAssistanceVal.branche,
            schedule: this.horaire,
            insurer_name: this.GtmAssistanceVal.insurer_name,
            step: 2,
            price: this.devis_price,
            channel: this.canal,
            event: "receive_call_step2",
          };
  
          Api()
            .post("assistances/create", assist)
            .then((resp) => {
              PushInDataLayer(Gtm2);
              if (resp.data.info == "ok") {
                this.$toasted.show(resp.data.msg, this.ToastTabSucess);
                this.assistanceDialog = false;
                this.horaire = "";
                this.canal = "";
                this.name = "";
                this.tel = "";
                this.objetRappel = "";
                this.remarques = "";
              } else if (resp.data.info == "nok") {
                this.$toasted.show(resp.data.msg, this.ToastTabError);
              }
            });
        } else {
          this.$toasted.show(
            "Tous les champs sont obligatoires !",
            this.ToastTabError
          );
        }
      },
  
      devisParMail: function (params) {
        Api()
          .get("devis/mydevisbyemail/" + params._id)
          .then((response) => {
            this.notifDeviParMail = response.data.info;
          });
      },
  
      // chargement du popup pour les infos de payement avec UPAY
      payement_start: function () {
        if (this.mode_payement) {
          if (this.mode_livraison) {
              if(this.Devis_pour_souscription.brancheid.branche == 'Voyage'){
              if(this.passagerIsOk != true){
                this.dialogInfoPassager = true
              }else {
                  this.begin_checkoutPushin();
                  let montant = this.mention_ttc;
                  localStorage.setItem("amount", montant);
                  let numDevis = this.Devis_pour_souscription.numeroDevis;
                  localStorage.setItem("numdevis", numDevis);
                  localStorage.setItem("canal", "Upay");
                  getUpay(this.mention_ttc, this.mode_payement);
              }
            }else if(this.Devis_pour_souscription.brancheid.branche == 'Santé'){
               if(this.assureIsOk != true){
                //this.dialogInfoAssure = true
                this.getBeneficiaries(store.state.user._id)
               }else {
                  this.begin_checkoutPushin();
                  let montant = this.mention_ttc;
                  localStorage.setItem("amount", montant);
                  let numDevis = this.Devis_pour_souscription.numeroDevis;
                  localStorage.setItem("numdevis", numDevis);
                  localStorage.setItem("canal", "Upay");
                  getUpay(this.mention_ttc, this.mode_payement);
               }
            }else {
                  this.begin_checkoutPushin();
                  let montant = this.mention_ttc;
                  localStorage.setItem("amount", montant);
                  let numDevis = this.Devis_pour_souscription.numeroDevis;
                  localStorage.setItem("numdevis", numDevis);
                  localStorage.setItem("canal", "Upay");
                  getUpay(this.mention_ttc, this.mode_payement);
            }
          } else {
            this.$toasted.show(
              "Mode livraison obligatoire !",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Mode de payement obligatoire !",
            this.ToastTabError
          );
        }
      },
  
      payment_free: function () {
        if (this.mode_payement) {
          if (this.mode_livraison) {
  
             if(this.Devis_pour_souscription.brancheid.branche == 'Voyage'){
              if(this.passagerIsOk != true){
                this.dialogInfoPassager = true
              }else {
                this.freepayment = true;
              }
            }else if(this.Devis_pour_souscription.brancheid.branche == 'Santé'){
               if(this.assureIsOk != true){
                //this.dialogInfoAssure = true
                this.getBeneficiaries(store.state.user._id)
               }else {
                 this.freepayment = true;
               }
            }else {
              this.freepayment = true;
            }
          } else {
            this.$toasted.show(
              "Mode livraison obligatoire !",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Mode de payement obligatoire !",
            this.ToastTabError
          );
        }
      },
  
      /*================ Debut de la Transaction par Free Money =======================*/
      Gopayment_free: function () {
        localStorage.setItem(
          "numdevis",
          this.Devis_pour_souscription.numeroDevis
        );
        localStorage.setItem("amount", this.mention_ttc);
        localStorage.setItem("canal", "FreeMoney");
        this.begin_checkoutPushin();
        this.snipperfree = true;
        FreeMoney(this.mention_ttc, this.Devis_pour_souscription.numeroDevis, this.numTelephone)
          .then((resp) => {
            if (resp.data) {
              setTimeout(() => {
                this.freepayment = false;
                this.$router.go(this.$router.push("/payment/freemoneyrep"));
              }, 50000);
            }
          })
          .catch((e) => {
            this.$router.go(this.$router.push("/payment/freemoneyrep"));
          });
      },
  
      payment_Orabank: function () {
        if (this.mode_payement) {
          if (this.mode_livraison) {
            if(this.Devis_pour_souscription.brancheid.branche == 'Voyage'){
              if(this.passagerIsOk != true){
                this.dialogInfoPassager = true
              }else {
                this.begin_checkoutPushin();
                let montant = this.mention_ttc;
                localStorage.setItem("amount", montant);
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Orabank");
                getOrabank(this.mention_ttc, this.mode_payement);
              }
            }else if(this.Devis_pour_souscription.brancheid.branche == 'Santé'){
               if(this.assureIsOk != true){
                //this.dialogInfoAssure = true
                 this.getBeneficiaries(store.state.user._id)
               }else {
                 this.begin_checkoutPushin();
                let montant = this.mention_ttc;
                localStorage.setItem("amount", montant);
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Orabank");
                getOrabank(this.mention_ttc, this.mode_payement);
               }
            }else {
                this.begin_checkoutPushin();
                let montant = this.mention_ttc;
                localStorage.setItem("amount", montant);
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Orabank");
                getOrabank(this.mention_ttc, this.mode_payement);
            }
          } else {
            this.$toasted.show(
              "Mode livraison obligatoire !",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Mode de payement obligatoire !",
            this.ToastTabError
          );
        }
      },
  
      // chargement du popup pour les infos de payement avec inTouch
      payement_intouch_start: function () {
        if (this.mode_payement) {
          if (this.mode_livraison) {
             if(this.Devis_pour_souscription.brancheid.branche == 'Voyage'){
              if(this.passagerIsOk != true){
                this.dialogInfoPassager = true
              }else {
                  this.begin_checkoutPushin();
                  let montant = this.mention_ttc;
                  localStorage.setItem("amount", montant);
                  let numDevis = this.Devis_pour_souscription.numeroDevis;
                  localStorage.setItem("numdevis", numDevis);
                  localStorage.setItem("canal", "inTouch");
                  inTouch(this.mention_ttc, this.mode_payement);
              }
             }else if(this.Devis_pour_souscription.brancheid.branche == 'Santé'){
               if(this.assureIsOk != true){
                //this.dialogInfoAssure = true
                 this.getBeneficiaries(store.state.user._id)
               }else {
                 this.begin_checkoutPushin();
                  let montant = this.mention_ttc;
                  localStorage.setItem("amount", montant);
                  let numDevis = this.Devis_pour_souscription.numeroDevis;
                  localStorage.setItem("numdevis", numDevis);
                  localStorage.setItem("canal", "inTouch");
                  inTouch(this.mention_ttc, this.mode_payement);
               }
            }else {
                  this.begin_checkoutPushin();
                  let montant = this.mention_ttc;
                  localStorage.setItem("amount", montant);
                  let numDevis = this.Devis_pour_souscription.numeroDevis;
                  localStorage.setItem("numdevis", numDevis);
                  localStorage.setItem("canal", "inTouch");
                  inTouch(this.mention_ttc, this.mode_payement);
             }
          } else {
            this.$toasted.show(
              "Mode livraison obligatoire !",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Mode de payement obligatoire !",
            this.ToastTabError
          );
        }
      },
  
      open_payment_om(){
        if (this.mode_payement) {
           if (this.mode_livraison) {
            this.choixOrangeMoneyPopup = true
           } else {
            this.$toasted.show(
              "Mode livraison obligatoire !",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Mode de payement obligatoire !",
            this.ToastTabError
          );
        }
      },
  
      payement_om_start: function () {
        if (this.mode_payement) {
          if (this.mode_livraison) {
              if(this.choixOrangeMoney){
                   if(this.Devis_pour_souscription.brancheid.branche == 'Voyage'){
              if(this.passagerIsOk != true){
                this.dialogInfoPassager = true
              }else {
                this.begin_checkoutPushin();
                let montant = this.mention_ttc;
                localStorage.setItem("amount", montant);
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Orange Money");
                this.choixOrangeMoneyPopup = false
                this.PopupOM = true // getOm(this.mention_ttc, this.mode_payement);
              }
              
            } else if(this.Devis_pour_souscription.brancheid.branche == 'Santé'){
               if(this.assureIsOk != true){
                //this.dialogInfoAssure = true
                this.getBeneficiaries(store.state.user._id)
               }else {
                 this.begin_checkoutPushin();
                  let montant = this.mention_ttc;
                  localStorage.setItem("amount", montant);
                  let numDevis = this.Devis_pour_souscription.numeroDevis;
                  localStorage.setItem("numdevis", numDevis);
                  localStorage.setItem("canal", "Orange Money");
                  this.choixOrangeMoneyPopup = false
                  this.PopupOM = true // getOm(this.mention_ttc, this.mode_payement);
               }
            } else {
              this.begin_checkoutPushin();
              let montant = this.mention_ttc;
              localStorage.setItem("amount", montant);
              let numDevis = this.Devis_pour_souscription.numeroDevis;
              localStorage.setItem("numdevis", numDevis);
              localStorage.setItem("canal", "Orange Money");
              this.PopupOM = true // getOm(this.mention_ttc, this.mode_payement);
              this.choixOrangeMoneyPopup = false
            }
              }
         
  
          } else {
            this.$toasted.show(
              "Mode livraison obligatoire !",
              this.ToastTabError
            );
          }
        } else {
          this.$toasted.show(
            "Mode de payement obligatoire !",
            this.ToastTabError
          );
        }
      },
  
      payement_wave_start: function () {
        if (this.mode_payement){
          if (this.mode_livraison){
             if(this.Devis_pour_souscription.brancheid.branche == 'Voyage'){
              if(this.passagerIsOk != true){
                this.dialogInfoPassager = true
              }else {
                let montant = this.mention_ttc;
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("amount", montant);
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Wave");
                wavepayment(this.mention_ttc, this.Devis_pour_souscription.numeroDevis)
              }
             } else if(this.Devis_pour_souscription.brancheid.branche == 'Santé'){
               if(this.assureIsOk != true){
                //this.dialogInfoAssure = true
                  this.getBeneficiaries(store.state.user._id)
               }else {
                 let montant = this.mention_ttc;
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("amount", montant);
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Wave");
                wavepayment(this.mention_ttc, this.Devis_pour_souscription.numeroDevis)
               }
            } else {
                let montant = this.mention_ttc;
                let numDevis = this.Devis_pour_souscription.numeroDevis;
                localStorage.setItem("amount", montant);
                localStorage.setItem("numdevis", numDevis);
                localStorage.setItem("canal", "Wave");
                wavepayment(this.mention_ttc, this.Devis_pour_souscription.numeroDevis)
             }
          } else {
            this.$toasted.show("Mode livraison obligatoire !",this.ToastTabError);
          }
        } else {
          this.$toasted.show("Mode de payement obligatoire !",this.ToastTabError);
        }
      },
  
      telecharger_le_devis: function (params) {
        Api()
          .get("devis/download/" + params._id)
          .then((response) => {
            let url = response.data.lien;
            this.dialogLoading = true;
            let WinOpener = null
            setTimeout(() => (this.dialogLoading = false, WinOpener = window.open(),WinOpener.location = url), 7000)
          })
      },
  
      assistanceDialogManip(devis) {
        this.devis_price = devis.prime_ttc;
        this.GtmAssistanceVal.branche = devis.brancheid.branche.toLowerCase();
        this.GtmAssistanceVal.insurer_name = devis.partenaireid.societe;
        this.GtmAssistanceVal.step = 1;
        this.GtmAssistanceVal.event = "receive_call_step1";
  
        PushInDataLayer(this.GtmAssistanceVal);
  
        this.objetRappel = "Devis : " + devis.numeroDevis;
        this.name =
          store.state.user.prenom.toUpperCase() +
          "-" +
          store.state.user.nom.toUpperCase();
        this.tel = store.state.user.telephone_port;
        this.assistanceDialog = true;
      },
  
      //  Ancienne fonction pour formattage de Date (:-)
      DateFormater: function (TheDate) {
        if (TheDate) {
          return dayjs(TheDate).format("DD-MM-YYYY");
        }
      },
  
      //Fonction permettant de fermer le popup liste passager et declencher popup Upay
      PayementSpecialVoyage() {
        this.dialogInfoPassager = false;
        getUpay(this.mention_ttc, this.mode_payement);
      },
  
      payement_end() {
        this.begin_checkoutPushin();
        store.dispatch("setOrderId", "IDO17102019-CNM");
        store.dispatch("setmodePaiement", this.mode_payement);
        this.$router.go(
          this.$router.push(
            "/payement/succes/?amanpay=1&apsuccess=1&aporderid=900032-78c8507&aptrxid=33778037902240883"
          )
        );
      },

  
      add_shipping_infoPushing() {
        let itemPushing = {
          event: "add_shipping_info",
          ecommerce: {
            shipping_tier: this.mode_livraison,
            items: this.addedInTheCard.ecommerce.items,
          },
        };
        PushInDataLayer(itemPushing);
      },
  
      /*=============================================================*/
      /*Prepare purchase data to Push purchase event in the dataLayer*/
      /*=============================================================*/
      purchasePushinPreparation() {
        let value =
          this.addedInTheCard.ecommerce.items[0].price +
          Math.round(this.DeliveryCost / 655.957);
        this.addedInTheCard.ecommerce.items[0].item_coupon = "";
  
        let purchasePushin = {
          event: "purchase",
          ecommerce: {
            transaction_id: null,
            affiliation: "",
            value: value,
            tax: Math.round(this.Devis_pour_souscription.taxe / 655.957),
            shipping: Math.round(this.DeliveryCost / 655.957),
            currency: "EUR",
            coupon: "",
            items: this.addedInTheCard.ecommerce.items,
          },
        };
        localStorage.setItem("purchasePushin", JSON.stringify(purchasePushin));
      },
  
      add_payment_infoPushing(Payment_Type) {
        let itemPushing = {
          event: "add_payment_info",
          ecommerce: {
            payment_type: Payment_Type,
            items: this.addedInTheCard.ecommerce.items,
          },
        };
        PushInDataLayer(itemPushing);
      },
  
      /*************************************************/
      /*Push begin_checkout Data and event to DataLayer*/
      /*************************************************/
      begin_checkoutPushin() {
        let itemPushing = {
          event: "begin_checkout",
          ecommerce: {
            items: this.addedInTheCard.ecommerce.items,
          },
        };
        PushInDataLayer(itemPushing);
      }
    },
  
    beforeDestroy() {
      this.purchasePushinPreparation();
      if (this.ExitByUser == true) {
        clearInterval(this.timer);
      } else {
        clearInterval(this.timer);
      }
    },
  
    watch: {
      notifDeviParMail: function () {
        if (this.notifDeviParMail == "ok") {
          this.$toasted.show(
            "Votre devis vous a été envoyé par mail",
            this.ToastTabSucess
          );
        } else {
          this.$toasted.show(
            "Le devis n'a pas pu être envoyé par mail",
            this.ToastTabError
          );
        }
      },
  
      mode_payement: function (val) {
        let PayType = "";
        switch (val) {
          case "mobile_money":
            PayType = "Orange Money";
            break;
          case "free_money":
            PayType = "Free Money";
            break;
          case "carte_bancaire":
            PayType = "Carte Bancaire";
            break;
          case "intouch":
            PayType = "Intouch";
            break;
          case "autre_paiement":
            PayType = "Autres paiements mobile";
            break;
        }
        this.add_payment_infoPushing(PayType);
      },
  
      mode_livraison: function () {
        this.add_shipping_infoPushing();
        this.mention_ttc = parseInt(this.svgTTC);
  
        if (this.mode_livraison == "a_domicile") {
          this.adresse = true;
          this.prix_livraison = null;
        } else if (this.mode_livraison == "reseau_partenaire") {
          this.mention_ttc = parseInt(this.svgTTC) + 500;
          localStorage.removeItem("adressliv");
        } else if (this.mode_livraison == "locaux_assuraf") {
          this.mention_ttc = parseInt(this.svgTTC);
          localStorage.removeItem("adressliv");
        }
        this.calculFraisLiv();
        this.calculFraisPaiement();
      },
    },
  
    mounted() {
      this.checkToken()
      this.getListePays();
      
      if (this.$store.state.user && this.$store.state.devispayement !== null) {
        this.wave_nom_prenom = this.$store.state.user.nom+" - "+this.$store.state.user.prenom
        this.mention_ttc = this.$store.state.devispayement.devis.prime_ttc;
        this.svgTTC = this.$store.state.devispayement.devis.prime_ttc;
        this.Devis_pour_souscription = this.$store.state.devispayement.devis;
        this.branche = this.$store.state.devispayement.devis.brancheid.branche;
        let view_itemPushing = {
          event: "add_to_cart",
          ecommerce: {
            items: [
              {
                item_name: "Assurance " + this.branche.toLowerCase(),
                item_id: this.Devis_pour_souscription.numeroDevis,
                price: Math.ceil(this.mention_ttc / 650),
                item_brand: this.Devis_pour_souscription.partenaireid.societe,
                item_category: this.branche,
                item_list_name: localStorage.getItem("item_list_name"),
                index: 1,
                quantity: "1",
              },
            ],
          },
        };
  
        this.addedInTheCard = view_itemPushing;
  
        if (document.readyState == "complete") {
          PushInDataLayer(view_itemPushing);
        }
  
        if (this.$store.state.devispayement.devis.brancheid.branche == "Automobile")
         {
          for (let index = 0;index < this.Devis_pour_souscription.vehicules.length;index++ ) {
            this.listegaranties.push(this.Devis_pour_souscription.vehicules[index].garanties);
          }
        } else {
          this.listegaranties = this.Devis_pour_souscription.garanties;
        }
    
        this.Mano = 20;
      } else {
        this.$router.go(this.$router.push("/"));
      }
    },
  };
  </script>
  
  <style lang="less" scoped>
  @import "../../assets/css/liste_devis.css";
  @import "../../assets/css/liste_devis_button.css";
  @import "../../assets/css/devis_css.css";
.body-color {
  background-color: #f9f3eb;
}
  /* Modern Checkout Styles */
.modern-checkout-title {
  // text-align: center;
  margin-bottom: 2rem;
  text-transform: uppercase;
}

.modern-checkout-title h2 {
  font-size: 2.5rem;
  font-weight: 500;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.modern-checkout-title.desktop h2 {
  font-size: 2.5rem;
}

.checkout-subtitle {
  font-size: 1.1rem;
  color: #7f8c8d;
  margin: 0;
}

.modern-checkout-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  margin-bottom: 2rem;
  border: none;
}

.modern-checkout-card.desktop {
  padding: 3rem;
}

.modern-payment-section {
  width: 100%;
}

.payment-methods-title {
  font-size: 2rem;
  font-weight: 600;
  color: #2c3e50;
  text-align: center;
  margin-bottom: 2rem;
}

.payment-methods-grid {
  display: grid;
  gap: 1rem;
  margin-bottom: 2rem;
}

.payment-methods-grid.mobile {
  grid-template-columns: repeat(2, 1fr);
}

.payment-methods-grid.desktop {
  grid-template-columns: repeat(5, 1fr);
  gap: 1.5rem;
}

.payment-method-item {
  position: relative;
}

.payment-radio {
  display: none;
}

.payment-label {
  display: block;
  background: #ffffff;
  border: 2px solid #e9ecef;
  border-radius: 15px;
  padding: 1.5rem 1rem;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.payment-label:hover {
  border-color: #ffa409;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 164, 9, 0.15);
}

.payment-radio:checked + .payment-label {
  border-color: #ffa409;
  background: linear-gradient(135deg, #ffa409 0%, #ff8c00 100%);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 164, 9, 0.3);
}

.payment-icon {
  margin-bottom: 0.5rem;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.payment-icon img {
  max-height: 35px;
  max-width: 60px;
  object-fit: contain;
  transition: all 0.3s ease;
}

.payment-icon.card-icons {
  display: flex;
  gap: 0.5rem;
}

.payment-icon.card-icons img {
  max-width: 35px;
  max-height: 25px;
}

.payment-radio:checked + .payment-label .payment-icon img {
  filter: brightness(0) invert(1);
}

.payment-name {
  font-size: 0.9rem;
  font-weight: 600;
  color: #2c3e50;
  transition: color 0.3s ease;
}

.payment-radio:checked + .payment-label .payment-name {
  color: white;
}

.payment-check {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 25px;
  height: 25px;
  background: #4CAF50;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transform: scale(0);
  transition: all 0.3s ease;
}

.payment-check i {
  color: white;
  font-size: 12px;
}

.payment-radio:checked + .payment-label .payment-check {
  opacity: 1;
  transform: scale(1);
}

/* Modern Coupon Section */
.modern-coupon-section {
  background: #f8f9fa;
  border-radius: 15px;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.modern-coupon-section.desktop {
  padding: 2rem;
}

.coupon-toggle {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .toggle-slider {
  background-color: #ffa409;
}

input:checked + .toggle-slider:before {
  transform: translateX(26px);
}

.toggle-label {
  font-size: 1rem;
  font-weight: 500;
  color: #2c3e50;
}

.coupon-input-section {
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.coupon-input-group {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.coupon-input {
  flex: 1;
  padding: 0.75rem 1rem;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

.coupon-input:focus {
  outline: none;
  border-color: #ffa409;
}

.coupon-apply-btn {
  padding: 0.75rem 1.5rem;
  background: linear-gradient(135deg, #ffa409 0%, #ff8c00 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.coupon-apply-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(255, 164, 9, 0.3);
}

/* Modern Summary Section */
.modern-summary-section {
  margin-top: 2rem;
}

.modern-summary-section.desktop {
  // margin-top: 3rem;
}

.summary-card {
  // background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  border: 1px solid #e9ecef;
}

.summary-card.desktop {
  padding: 2.5rem;
}

.summary-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 2rem;
}

.summary-left {
  flex: 1;
}

.summary-right {
  flex: 0 0 300px;
  text-align: right;
}

.summary-title {
  font-size: 2rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 1.5rem;
  text-align: center;
}

.summary-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid #e9ecef;
}

.summary-item:last-child {
  border-bottom: none;
}

.summary-item.discount {
  background: linear-gradient(135deg, #e8f5e8 0%, #f0f8f0 100%);
  margin: 0.5rem -1rem;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  border-bottom: none;
}

.summary-label-desktop {
  font-size: 1.2rem;
  color: #6c757d;
  font-weight: 500;
}

.summary-label {
  font-size: 1.5rem;
  color: #6c757d;
  font-weight: 500;
}

.summary-value {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2c3e50;
}

.summary-value.original-price {
  text-decoration: line-through;
  color: #6c757d;
}

.summary-value.discount-value {
  color: #28a745;
}

.payment-method-name {
  color: #ffa409;
}

.summary-total {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  color: white;
  padding: 1.5rem;
  border-radius: 15px;
  margin: 1.5rem 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.total-label {
  font-size: 1.2rem;
  font-weight: 600;
}

.total-value {
  font-size: 1.8rem;
  font-weight: 700;
}

.payment-action {
  text-align: center;
  margin-top: 1.5rem;
}

.modern-pay-btn {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 200px;
  justify-content: center;
}

.modern-pay-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 25px rgba(40, 167, 69, 0.3);
}

.modern-pay-btn:active {
  transform: translateY(-1px);
}

.modern-pay-btn i {
  font-size: 1rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .payment-methods-grid.mobile {
    grid-template-columns: 1fr;
  }
  
  .payment-label {
    min-height: 100px;
    padding: 1rem;
  }
  
  .coupon-input-group {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .coupon-input,
  .coupon-apply-btn {
    width: 100%;
  }
  
  .summary-content {
    flex-direction: column;
    gap: 1rem;
  }
  
  .summary-right {
    flex: none;
    text-align: center;
    width: 100%;
  }
}

@media (max-width: 480px) {
  .modern-checkout-title h2 {
    font-size: 2rem;
  }
  
  .payment-methods-title {
    font-size: 1.5rem;
  }
  
  .modern-checkout-card {
    padding: 1.5rem;
  }
  
  .summary-card {
    padding: 1.5rem;
  }
}

/* Animation for payment method selection */
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.payment-radio:checked + .payment-label {
  animation: pulse 0.6s ease;
}

/* Loading state for payment button */
.modern-pay-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.modern-pay-btn:disabled:hover {
  transform: none;
  box-shadow: none;
}







  /* .row-container {
      background: white;
  } */
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: 15px;
  }
  .to-top {
    margin-top: -5%;
  }
  
  .to-left {
    text-align: left;
  }
  
  .to-right {
    float: right;
    padding-left: 50px;
  }
  
  .to-right-mobile {
    float: right;
    margin-right: 2%;
  }
  
  .to-right-tablet {
    float: right;
    font-size: 12px;
  }
  
  .to-left span {
    color: black;
    font-weight: bold;
  }
  
  .table-donnees {
    border-collapse: collapse;
  }
  
  .table-donnees tr td {
    border: 1px solid lightgrey !important;
  }
  
  .List-cout li {
    list-style: none;
  }
  
  .list-boutons li {
    list-style: none;
  }
  
  .logo-assureur {
    border: 1px solid lightgrey;
  }
  
  .right--texting {
    text-align: right;
  }
  
  .right--texting ul li .col-lg-6:hover {
    background: #ffa409;
    color: white;
    text-decoration: none;
  }
  
  .answer {
    position: relative;
    margin-right: 0;
    float: left;
    display: block;
    margin-right: 2.12766%;
    width: 100%;
  }
  
  .highlight {
    padding: 6px 12px;
    display: -ms-flexbox;
    display: flex;
    position: relative;
    font-size: 0.0625rem;
    cursor: pointer;
    color: #6d6d6d;
    border: solid 1px transparent;
    border-bottom: solid 1px #e9e9e9;
    border-radius: 3px;
    transition: background 0.4s;
  }
  
  .highlight:hover {
    background-color: rgba(255, 164, 9, 0.3);
    padding-left: 10px;
    transition-duration: 0.5s;
  }
  
  ul li {
    list-style: none;
    padding-top: 7px;
  }
  
  .container {
    padding: 0px !important;
  }
  
  .uppercase {
    font-weight: bold;
    color: #ffa409;
    text-transform: uppercase;
    font-size: 16px;
  }
  
  .head {
    background-color: rgb(91, 148, 188);
    color: white;
    font-size: 18px;
  }
  
  .selectatMobile {
    background: url(https://)
      no-repeat right;
    -webkit-appearance: none;
    background-position-x: 95%;
    border-bottom: 1px solid gray;
  }
  
  .selectatDesktop {
    background: url(https://)
      no-repeat right;
    -webkit-appearance: none;
    background-position-x: 90%;
    border-bottom: 1px solid gray;
  }
  
  .georgia {
    font-family: Georgia !important;
  }
  
  .border-radius {
    border-radius: 20px !important;
  }
  
  .card-desktop {
    height: 150px !important;
    width: 150px !important;
  }
  
  .form .plan input,
  .form .payment-plan input,
  .form .payment-type input {
    display: none;
  }
  
  .form label {
    /* margin-top: 15px; */
    width: 120px;
    position: relative;
    color: #333;
    font-family: Georgia !important;
    border-radius: 20px !important;
    background-color: #fff;
    font-size: 15px;
    text-align: center;
    height: 120px;
    display: block;
    cursor: pointer;
    border: 3px solid transparent;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  
  .form .plan input:checked + label,
  .form .payment-plan input:checked + label,
  .form .payment-type input:checked + label {
    border-radius: 20px !important;
    background-color: #ffa409;
    color: #fff;
  }
  
  .form .plan input:checked + label:after,
  form .payment-plan input:checked + label:after,
  .form .payment-type input:checked + label:after {
    content: "\2713";
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 100%;
    border: 2px solid #ffa409;
    background-color: #fff;
    color: #ffa409;
    z-index: 999;
    position: absolute;
    top: -10px;
    right: -10px;
  }
  
  /*================== CSS SELECT GLOBAL AUTO===================*/
  /* Reset Select */
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    outline: 0;
    box-shadow: none;
  
    background: #fff;
  }
  
  /* Remove IE arrow */
  select::-ms-expand {
    display: none;
  }
  
  select {
    flex: 1;
    padding: 0 0.5em;
    color: grey;
    cursor: pointer;
  }
  
  /*================== CSS SELECT DESKTOP AUTO===================*/
  /* Custom Select */
  .select {
    position: relative;
    display: flex;
    width: 100%;
    height: 3em;
    line-height: 3;
    background: #fff;
    overflow: hidden;
    border: 2px solid #d3d3d3 !important;
    border-radius: 35px;
  }
  
  /* Arrow */
  .select::after {
    content: "\2228";
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 1em;
    background: #fff;
    cursor: pointer;
    pointer-events: none;
    -webkit-transition: 0.25s all ease;
    -o-transition: 0.25s all ease;
    transition: 0.25s all ease;
  }
  
  /* Transition */
  .select:hover::after {
    color: #f39c12;
  }
  
  /*css popup Free*/
  
  .containerP {
    margin-top: 15px;
    font-family: PT Sans, sans-serif;
    font-size: 18px;
    max-width: 500px;
    height: 500px;
    background: white;
    border-radius: 9px;
    overflow: hidden;
  }
  
  .icing,
  .dough {
    float: left;
    padding: 20px;
    box-sizing: border-box;
    height: 100%;
    display: -webkit-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
    text-align: center;
  }
  
  .icing {
    width: 33%;
    position: relative;
    padding-right: 24px;
    background: -webkit-gradient(
      linear,
      left top,
      right top,
      from(#ffa409),
      color-stop(100%, #6c757d)
    );
    background: linear-gradient(to right, #ffa409 100%, #6c757d 80%);
    color: white;
  }
  
  .icing:before {
    content: "";
    width: 36px;
    height: 36px;
    display: block;
    position: absolute;
    top: -18px;
    right: -7.2px;
    z-index: 1;
  }
  
  .dough {
    width: 67%;
    padding-left: 36px;
    color: black;
  }
  
  .order {
    -webkit-box-flex: 1;
    flex-grow: 1;
    /* padding: 20px 0;
          margin: 20px 0; */
    border: 1px solid white;
    border-color: white transparent;
    font-weight: bold;
    font-size: 18px;
    text-align: center;
  }
  
  .order li {
    display: -webkit-box;
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    text-align: center;
  }
  
  h2 {
    font-size: 1.2em;
  }
  
  .total {
    font-size: 22px;
    text-align: center;
    font-weight: bold;
  }
  
  .inputs {
    -webkit-box-flex: 1;
    flex-grow: 1;
  }
  
  .rowFree {
    width: 100%;
    display: -webkit-box;
    display: flex;
    -webkit-box-align: end;
    align-items: flex-end;
    margin-bottom: 6px;
  }
  
  .rowFreeMobile {
    /* width: 100%; */
    display: -webkit-box;
    display: flex;
    -webkit-box-align: end;
    align-items: flex-end;
    margin-bottom: 6px;
  }
  
  .column {
    width: 100%;
  }
  
  .column:not(:last-child) {
    margin-right: 10px;
  }
  
  .label,
  .text-input {
    float: left;
    display: block;
    clear: both;
  }
  
  .label {
    font-size: 0.8em;
    margin-bottom: 0.2em;
  }
  
  .text-input {
    box-sizing: border-box;
    width: 90%;
    padding: 10px;
    font-size: 1em;
    font-family: inherit;
    background: white;
    border: 1px solid #ffa409;
    border-radius: 5px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1) inset;
  }
  
  .name-group {
    -webkit-box-flex: 1;
    flex-grow: 1;
    flex-basis: 200px;
  }
  
  .order-button {
    padding: 10px 20px;
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    font-family: inherit;
    color: inherit;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid rgba(144, 81, 14, 0.3);
    box-shadow: 0 2px 2px rgba(144, 81, 14, 0.1);
    border-radius: 5px;
    -webkit-transition: background 0.1s, color 0.1s, border-color 0.1s;
    transition: background 0.1s, color 0.1s, border-color 0.1s;
  }
  
  .buttonFRMobile {
    padding: 10px 20px;
    width: 100%;
    box-sizing: border-box;
    font-size: 13px;
    font-family: inherit;
    color: inherit;
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid rgba(144, 81, 14, 0.3);
    box-shadow: 0 2px 2px rgba(144, 81, 14, 0.1);
    border-radius: 5px;
    -webkit-transition: background 0.1s, color 0.1s, border-color 0.1s;
    transition: background 0.1s, color 0.1s, border-color 0.1s;
  }
  
  .order-button:hover {
    background: #ffa409;
    color: white;
    border-color: transparent;
  }
  
  .policeLato {
    font-family: Lato, "Helvetica Neue", Arial, sans-serif;
  }
  .container_forma {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  
  .file-upload-wrapper {
    border: 1px solid #d9dee3;
    border-radius: 5px;
    position: relative;
    width: 100%;
    height: 55px;
  }
  .file-upload-wrapper:after {
    content: attr(data-text);
    font-size: 18px;
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    padding: 10px 15px;
    display: block;
    width: calc(100% - 40px);
    pointer-events: none;
    z-index: 20;
    height: 40px;
    line-height: 40px;
    color: #999;
    border-radius: 5px 10px 10px 5px;
    font-weight: 300;
  }
  .file-upload-wrapper:before {
    content: 'Ajouter';
    position: absolute;
    top: -1px;
    right: -2px;
    display: inline-block;
    height: 55px;
    background: #acabab;
    color: #fff;
    font-weight: 700;
    z-index: 25;
    font-size: 16px;
    line-height: 60px;
    padding: 0 15px;
    text-transform: capitalize;
    pointer-events: none;
    border-radius: 0 5px 5px 0;
  }
  .file-upload-wrapper:hover:before {
    background: #ffa409;
  }
  .file-upload-wrapper input {
    opacity: 0;
    border: 2px;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 99;
    height: 40px;
    margin: 0;
    padding: 0;
    display: block;
    cursor: pointer;
    width: 100%;
  }
  
  
  
  
  
  
  
  .middle {
    width: auto;
    text-align: center;
    /* Made by */
  }
  .middle h1 {
    font-family: "Inter", sans-serif;
    color: #fff;
  }
  .middle input[type="radio"] {
    display: none;
  }
  .middle input[type="radio"]:checked + .box {
    background-color: rgba(255, 164, 9, 0.07);
    transition: all .33s ease;
    border: 2px solid #ffa409;
    color: #29323a;
  }
  .middle input[type="radio"]:checked + .box span {
    color: #29323a;
    transform: translateY(70px);
  }
  .middle input[type="radio"]:checked + .box span:before {
    transform: translateY(0px);
    opacity: 1;
  }
  .middle .box {
    width: 220px;
    height: 150px;
    border-radius: 12px;
    background-color: #fff;
    transition: all 250ms ease;
    will-change: transition;
    display: inline-block;
    text-align: center;
    cursor: pointer;
    position: relative;
    box-shadow: 0 4px 8px rgb(172 186 200 / 10%);
    font-size: 10px;
    border: 1px solid #d9dee3;
    font-family: Open Sans,sans-serif;
    font-weight: 900;
  }
  .middle .box:hover {
    background-color: rgba(255, 164, 9, 0.07);
    transition: all .33s ease;
    border: 2px solid #ffa409;
  }
  .middle .box:hover span {
    color: #29323a;
  }
  
  .middle .box:active {
    transform: translateY(10px);
  }
  .middle .box span {
    position: absolute;
    transform: translate(0, 60px);
    left: 0;
    right: 0;
    padding-top: 15%;
    transition: all 300ms ease;
    font-size: 1.5em;
    user-select: none;
    color: #29323a;
  }
  .middle .box span:before {
    font-size: 1.2em;
    font-family: FontAwesome;
    display: block;
    transform: translateY(-80px);
    opacity: 0;
    transition: all 300ms ease-in-out;
    font-weight: normal;
    color: #fff;
  }
  .middle p {
    color: #fff;
    font-family: "Inter", sans-serif;
    font-weight: 400;
  }
  .middle p a {
    text-decoration: underline;
    font-weight: bold;
    color: #fff;
  }
  .middle p span:after {
    content: "\f0e7";
    font-family: FontAwesome;
    color: yellow;
  }
  
  .switch, *::before, *::after {
    box-sizing: border-box;
    margin-bottom: 20px!important;
  }
  .switch input[type='checkbox'] {
    appearance: none;
    display: block;
    margin: 0;
  }
  .switch label {
    color: #29323a;
    font-size: 17px!important;
    display: block;
    height: 2.375rem;
    position: relative;
    cursor: pointer;
    padding-left: 7rem;
    padding-top: 3px!important;
  }
  .switch input[type='checkbox'] + label::before {
    content: 'Non';
    text-align: right;
    font-size: 1.3rem;
    padding: 0.375rem 0.5rem;
    color: #fff;
    display: block;
    height: 2.5rem;
    width: 5.5rem;
    border-radius: 9999px;
    position: absolute;
    top: calc(0.375rem - 1px);
    left: 5px;
    background-color: #8f8f8f;
    box-shadow: 0 0 0 1px #e0e0e0;
    transition: all 0.3s cubic-bezier(0.72, 0.26, 0.26, 0.82), visibility 0s;
  }
  .switch input[type='checkbox'] + label::after {
    content: '';
    display: block;
    height: 2.5rem;
    width: 2.5rem;
    border: solid 0.25rem #8f8f8f;
    border-radius: 9999px;
    position: absolute;
    top: calc(0.375rem - 1px);
    left: 5px;
    background-color: #fff;
    transition: all 0.3s cubic-bezier(0.72, 0.26, 0.26, 0.82), visibility 0s;
  }
  .switch input[type='checkbox']:checked + label::before {
    content: 'Oui';
    text-align: left;
    background-color: #ffa409;
  }
  .switch input[type='checkbox']:checked + label::after {
    left: 3.5rem;
    border-color: #ffa409;
  }
  
  </style>
  